import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomSortDescendOutlined = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M6.022 5.077V15.63h1.686c.413 0 .628.581.328.915L5.422 19.54a.437.437 0 0 1-.665 0l-2.615-2.995c-.3-.334-.094-.915.328-.915h1.677V5.077c0-.592.422-1.077.938-1.077.515 0 .937.485.937 1.077m8.331 14.615h-2.47c-.68 0-1.236-.588-1.236-1.307 0-.72.556-1.308 1.235-1.308h2.471c.68 0 1.235.588 1.235 1.308 0 .719-.556 1.307-1.235 1.307m-2.47-13.077c-.68 0-1.236-.588-1.236-1.307 0-.72.556-1.308 1.235-1.308h9.883C22.445 4 23 4.588 23 5.308c0 .719-.556 1.307-1.235 1.307zm6.176 6.539h-6.177c-.679 0-1.235-.589-1.235-1.308s.556-1.307 1.235-1.307h6.177c.68 0 1.235.588 1.235 1.307 0 .72-.556 1.308-1.235 1.308"
  />,
  'CustomSortDescendOutlined',
);

export default CustomSortDescendOutlined;
